function Setup() {
    return (<div>
        <div className="container-fluid text-center">
          <a href="/"><button className="abs-center-x no-click btn btn-dark" style={{fontSize: '25px'}}>WIT&amp;SKILLDULE</button></a>
          {/* <div class="btn-group dropstart ms-auto">
  <button type="button" class="btn btn-dark" style="font-size: 25px;" data-bs-toggle="dropdown" aria-expanded="false">
    ☰
  </button>
  <ul class="dropdown-menu" style="background-color: #0072CF">
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#cs">Copy Schedule</button></li>
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#setSchedule">Change Schedule</button></li>

    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#settings">Settings</button></li>

    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#faq">Help!</button></li>
  </ul>

</div> */}
        </div>
        <div className="container-fluid">
          <h2>Setting Up Skilldule</h2>
          <p className="lead">This page includes tutorials on how to fully setup Skilldule. If you have any questions, please contact <a href="mailto:ctc@fwparker.org">CTC</a>.
          </p><div className="pt-4 pb-4 row justify-content-center">
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item" style={{backgroundColor: '#F5B700'}}>
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button className="accordion-button text-light" style={{backgroundColor: '#F5B700'}} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                    #1 Adding Your Schedule
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                  <div className="accordion-body">
                    <div className="text-center"><iframe width={560} height={315} src="https://www.youtube.com/embed/uJLWr5I6c_M" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
                    <ol>
                      <li>Click the Get Started button on the home page</li>
                      <li>Click the Copy Code Button</li>
                      <li>Go to the progress page of the portal</li>
                      <li>Use CMD-Shift-I(Mac), CTRL-Shift-I(Windows) to open up the console.</li>
                      <li>Paste the code into the console</li>
                      <li>Copy the text that the code returns</li>
                      <li>Paste the text into Skilldule</li>
                      <li>Click the Login & Submit button (Recomendded to access schedule on multiple devices with ease). Alternativly you can save your schedule locally and export it to other devices.</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="accordion-item" style={{backgroundColor: '#DB0030'}}>
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button style={{backgroundColor: '#DB0030'}} className="accordion-button collapsed text-light" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                    #2 Adding Homework
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                  <div className="accordion-body">
                    <div className="text-center"><iframe width={560} height={315} src="https://www.youtube.com/embed/Powzh9PQ0SU" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
                    Portal:
                    <ol>
                      <li>Open Skilldule Settings</li>
                      <li>In another tab open the Portal, and click the Calender Tab</li>
                      <li>Click the rotated wifi symbol</li>
                      <li>Under My Calender, open the individual filter feeds menu.</li>
                      <li>Right Click Assignments</li>
                      <li>Click Copy Link Address</li>
                      <li>Paste link under Assignment Webcal URL</li>
                      <li>Click the Save button</li>
                    </ol>
                    Google Classroom:
                    <ol>
                      <li>Open Skilldule Settings</li>
                      <li>Click Connect to Google Classroom</li>
                      <li>Follow the instructions and make sure you approve all the permissions</li>
                      <li>After it returns you to Skilldule, go back to settings</li>
                      <li>A list of all your classes with a dropdown under each will appear</li>
                      <li>Select whether you want the class to retirve homework from the Portal(default) or choose a Google Classroom Class from the dropdown to link)
                      </li><li>Click the Save button</li>
                    </ol>
                  </div>
                </div>
              </div>
              {/* <div className="accordion-item" style={{backgroundColor: '#2CBF1B'}}>
                <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                  <button className="accordion-button collapsed text-light" style={{backgroundColor: '#2CBF1B'}} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    #3 Connecting to Skilldule Chats
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                  <div className="accordion-body">
                    <div className="text-center"><iframe width={560} height={315} src="https://www.youtube.com/embed/QPyKaLJl1Cc" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>   
                    <ol>
                      <li>Open the Discord menu</li>
                      <li>Click Connect</li>
                      <li>Log in to Discord/Create an Account</li>
                      <li>Click Authorize</li>
                      <li>You will now be in the Skilldule Chats Discord Server, under the Classes section will be all of your classes</li>
                    </ol>
                  </div>
                </div>
              </div> */}
              <div className="accordion-item" style={{backgroundColor: '#FE5E41'}}>
                <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                  <button className="accordion-button collapsed text-light" style={{backgroundColor: '#FE5E41'}} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    #3 Modifying Settings &amp; Exporting
                  </button>
                </h2>
                <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                  <div className="accordion-body">
                    <div className="text-center"><iframe width={560} height={315} src="https://www.youtube.com/embed/3CriEfDDNgo" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div> 
                    Modifying Settings:
                    <ol>
                      <li>Open the Settings menu</li>
                      <li>There you will find all the settings for the Skilldule</li>
                      <li>Choose the options you want.</li>
                      <li>Click the Save button</li>
                    </ol>
                    Exporting (Local Schedule only):
                    <ol>
                      <li>Open the Copy Schedule menu</li>
                      <li>Scan the QR with your mobile device Camera App(Apple), Google Lens(Andrioid)</li>
                      <li>On your mobile device, add Skilldule to your homescreen by clicking share button and then add to home screen</li>
                      <li>OR Copy the link from the Copy Scedule menu and open on another device</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row footer pt-4 text-center">
              <p className="lead">WIT&amp;SKILLDULE is a division of the <a href="https://media.discordapp.net/attachments/784994278966951936/981220444680118312/binbows.png" target="_blank">JSFFund of America</a></p>
            </div>
          </div>
        </div></div>)
}

export default Setup;